import { Chat } from "./chat";
import { Dashboard } from "./dashboard";

async function main() {
    const dashboard = new Dashboard();

    const chat = new Chat("ask");
    chat.assistant_hook = (layout) => dashboard.update(layout);
    chat.register();
}

window.addEventListener("load", main);
